import React, { ReactNode } from 'react';
import { Text, TextProps } from '@mantine/core';
import clsx from 'clsx';

interface ShowMessageProps extends Omit<TextProps, 'children' | 'className'> {
    when: boolean;
    children: ReactNode;
    variant?: 'error' | 'muted' | 'info' | 'warning';
    className?: string;
    fallback?: ReactNode;
}

const variantClasses = {
    error: 'text-red-600 font-medium',
    muted: 'text-gray-500 dark:text-gray-400',
    info: 'text-blue-600 dark:text-blue-400',
    warning: 'text-amber-600 dark:text-amber-500',
} as const;

export function ShowMessage({
    when,
    children,
    variant = 'muted',
    className,
    fallback = null,
    ...textProps
}: ShowMessageProps) {
    if (!when) return fallback;

    return (
        <Text
            ta="center"
            py="xl"
            className={clsx(
                'text-center min-h-[8rem] flex items-center justify-center',
                variantClasses[variant],
                className,
            )}
            {...textProps}
        >
            {children}
        </Text>
    );
}
